import axios from 'axios'
import library from '../../../utils/Library'

export const getOrganizationAccessStatus = async (orgId) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('e_authz') + '/getOrgApplicationAccessStatusEAuthz'

  return await axios({
    url: URL,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: {
      appCode: 'ME',
      organizationId: orgId
    }
  })
}
